// ============================================================================
// DOM UTILS - Utility per selettori DOM sicuri
// ============================================================================
// Fornisce wrapper null-safe intorno a querySelector/querySelectorAll.
// Usare queste funzioni al posto di jQuery $() per:
//   - evitare eccezioni su elementi non presenti nel DOM
//   - rendere espliciti i null-check prima di aggiungere listener
// ============================================================================

/**
 * Ritorna il primo elemento che corrisponde al selettore, o null se non trovato.
 * Restituisce null anche se il selettore è falsy.
 *
 * @param {string} selector - Selettore CSS
 * @param {Element|Document} [context=document] - Contesto di ricerca
 * @returns {Element|null}
 */
export const qs = (selector, context = document) => (selector ? context.querySelector(selector) : null);

/**
 * Ritorna tutti gli elementi che corrispondono al selettore.
 * Restituisce un array vuoto se il selettore è falsy o nessun elemento è trovato.
 *
 * @param {string} selector - Selettore CSS
 * @param {Element|Document} [context=document] - Contesto di ricerca
 * @returns {Element[]}
 */
export const qsAll = (selector, context = document) => (selector ? Array.from(context.querySelectorAll(selector)) : []);
